import { createContext, useContext } from "react";
import { SelectedItemsForSync } from "../../types/selectedItemsForSync";

export const selectedItemsForSyncContext = createContext<{
  selectedItemsForSync: SelectedItemsForSync;
  setSelectedItemsForSync: React.Dispatch<React.SetStateAction<SelectedItemsForSync>>;
} | null>(null);

export function useSelectedItemsForSyncContext() {
  const context = useContext(selectedItemsForSyncContext);
  if (!context) {
    throw new Error("useSelectedItemsForSyncContext must be used within a SelectedItemsForSyncProvider");
  }
  return context;
}